var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPremium = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "premium_svg__a",
    d: "M10 16c-.351 0-.688-.14-.925-.389L.325 6.408a1.156 1.156 0 0 1-.035-1.57L4.13.43c.238-.274.59-.43.96-.43h9.823c.372 0 .723.156.96.43l3.838 4.407c.4.46.384 1.13-.035 1.571l-8.75 9.203a1.27 1.27 0 0 1-.925.389z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "premium_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#premium_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#premium_svg__a",
    fill: "#A6A6A6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A6",
    fillRule: "nonzero",
    d: "M-2 0h12v17H-2z",
    mask: "url(#premium_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "nonzero",
    d: "M-2 0h24v6H-2z",
    mask: "url(#premium_svg__b)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPremium);
export { ForwardRef as ReactComponent };